import React from 'react';
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/react';
import {Link} from 'react-router-dom';

interface PlayerReportActionProps {
  playerId: string;
  playerRouteRoot: string;
  capabilities: readonly string[];
}

const reportActions = [
  {type: 'scouting', label: 'Scouting report', capability: 'report.create.scouting'},
  {type: 'performance', label: 'Performance report', capability: 'report.create.performance'},
  {type: 'training', label: 'Training report', capability: 'report.create.training'},
  {type: 'medical', label: 'Medical report', capability: 'report.create.medical'},
] as const;

const actionClass = 'inline-flex min-h-11 items-center rounded-md bg-club-blue-600 px-3 text-sm font-semibold text-white hover:bg-club-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900';

const PlayerReportAction: React.FC<PlayerReportActionProps> = ({playerId, playerRouteRoot, capabilities}) => {
  const allowedActions = reportActions.filter(action => capabilities.includes(action.capability));
  const href = (type: typeof reportActions[number]['type']) => {
    const query = new URLSearchParams({
      playerId,
      returnTo: `${playerRouteRoot}/${playerId}?tab=reports`,
    });
    return `/reports/${type}/new?${query}`;
  };

  if (allowedActions.length === 0) return null;
  if (allowedActions.length === 1) {
    return <Link className={actionClass} to={href(allowedActions[0].type)}>Add report</Link>;
  }

  return (
    <Menu as="div" className="relative">
      <MenuButton className={actionClass}>Add report</MenuButton>
      <MenuItems className="absolute right-0 z-20 mt-2 w-52 rounded-md bg-white p-1 shadow-lg ring-1 ring-black/10 focus:outline-none dark:bg-gray-900 dark:ring-white/10">
        {allowedActions.map(action => (
          <MenuItem key={action.type}>
            <Link className="block rounded px-3 py-2 text-sm font-medium text-gray-700 data-[focus]:bg-gray-100 dark:text-gray-200 dark:data-[focus]:bg-gray-800" to={href(action.type)}>
              {action.label}
            </Link>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default PlayerReportAction;
